const GA_MEASUREMENT_ID = "G-Z54D6CNKX5";

/** SPA route changes: GA4 expects a new `config` with `page_path` (see GA4 SPA docs). */
export function trackPageView(path: string) {
  if (typeof window.gtag !== "function") return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_location: window.location.href,
  });
}
